import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import CardView from './View';
import schema from './schema';

interface CardsBlockData {
  '@type': 'cards';
  stackable?: boolean;
  itemsPerRow?: number;
}

interface CardsEditViewProps {
  selected?: boolean;
  block: string;
  data: CardsBlockData;
  onChangeBlock: (
    block: string,
    data: CardsBlockData,
  ) => void;
}

const CardsEditView = ({
  selected,
  block,
  data,
  onChangeBlock,
}: CardsEditViewProps) => {
  return (
    <>
      {/* override to target semantic ui image classes in edit view */}
      <div className="cards-edit">
        <CardView 
          data={data}
          isEditMode
        />
      </div>

      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          formData={data}
          block={block}
          onChangeField={(id: string, value: unknown) =>
            onChangeBlock(block, {
              ...data,
              [id]: value,
            } as CardsBlockData)
          }
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default CardsEditView;